import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=b4ebbcf0&"
import script from "./UserManager.vue?vue&type=script&lang=js&"
export * from "./UserManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports